import React from 'react';

const ProgressBar = ({ currentStep, totalSteps, steps }) => {
  const progressPercentage = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className="px-2 py-2 sm:px-3 sm:py-2 md:px-4 md:py-3 border-b border-gray-200">
      {/* Progress Bar */}
      <div className="mb-2 md:mb-3">
        <div className="flex justify-between text-xs text-gray-600 mb-1">
          <span className="font-medium">Progress</span>
          <span>{currentStep + 1} of {totalSteps}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-1.5">
          <div 
            className="bg-blue-600 h-1.5 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>

      {/* Step Indicators - Mobile Optimized */}
      <div className="hidden md:flex justify-between">
        {steps.map((step, index) => (
          <div key={step.id} className="flex flex-col items-center">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
              index < currentStep 
                ? 'bg-green-500 text-white' 
                : index === currentStep
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-500'
            }`}>
              {index < currentStep ? (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              ) : (
                index + 1
              )}
            </div>
            <span className={`mt-2 text-xs text-center ${
              index <= currentStep ? 'text-gray-900 font-medium' : 'text-gray-500'
            }`}>
              {step.title}
            </span>
          </div>
        ))}
      </div>

      {/* Mobile Step Indicator */}
      <div className="md:hidden flex justify-center space-x-2">
        {steps.map((step, index) => (
          <div key={step.id} className={`w-3 h-3 rounded-full transition-colors ${
            index < currentStep 
              ? 'bg-green-500' 
              : index === currentStep
              ? 'bg-blue-600'
              : 'bg-gray-200'
          }`} />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
